import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useList(path, deps = []) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    if (!path) return [];
    const { data } = await api.get(path);
    setItems(data);
    setLoading(false);
    return data;
  }, [path]); // eslint-disable-line
  useEffect(() => { reload(); }, [reload, ...deps]); // eslint-disable-line
  return { items, setItems, reload, loading };
}

export const usePages = (bookId) => useList(bookId ? `/books/${bookId}/pages` : null);
export const useCharacters = (bookId) => useList(bookId ? `/books/${bookId}/characters` : null);
